import React from "react";
import { NoSettings } from "./sectionFormKit";

// Customer: components/sections/AccountLayout/AccountLayout.js
const AccountLayout = () => (
  <NoSettings text="Customer dashboard layout: sidebar plus this page's other sections. Guests see a sign-in prompt. No settings." />
);

export default AccountLayout;
